import OfficeBuildingIcon from './OfficeBuildingIcon';
export default OfficeBuildingIcon;
